export default __webpack_public_path__ + "049715899e8e7b638fcc5e41eac24bfd.png";